import React from 'react';
import {
  BOLD_CLASS,
  GREY_BG_CLASS,
  ITALIC_CLASS,
  LEFT_ALIGN_CLASS,
  METADATA_GREY_BG_CLASS,
  OUT_OF_RANGE_CELL_CLASS,
  PROXY_CELL_CLASS,
  RIGHT_ALIGN_CLASS,
  ROW_HAS_ERROR_CLASS,
} from './customAnalysisContants';
import { cn } from '@/lib/utils';

export const GridWrapper = ({
  children,
  isReport,
  className,
}: React.BaseHTMLAttributes<HTMLDivElement> & { isReport?: boolean }) => (
  <div
    className={cn(
      isReport ? undefined : 'overflow-auto',
      `[&_.${BOLD_CLASS}]:font-bold [&_.${ITALIC_CLASS}]:italic [&_.${LEFT_ALIGN_CLASS}]:text-left [&_.${RIGHT_ALIGN_CLASS}]:text-right`,
      `[&_.${GREY_BG_CLASS}]:bg-venn-grey-10 [&_.${GREY_BG_CLASS}]:text-venn-grey-80`,
      `[&_.${METADATA_GREY_BG_CLASS}]:bg-venn-grey-10 [&_.${METADATA_GREY_BG_CLASS}]:text-venn-grey-80`,
      `[&_.${METADATA_GREY_BG_CLASS}]:overflow-hidden [&_.${METADATA_GREY_BG_CLASS}]:text-ellipsis [&_.${METADATA_GREY_BG_CLASS}]:whitespace-nowrap`,
      `[&_.${ROW_HAS_ERROR_CLASS}]:bg-venn-error/10 [&_.${PROXY_CELL_CLASS}]:bg-venn-deprecated-data-line-pale-gold/10`,
      `[&_.${OUT_OF_RANGE_CELL_CLASS}]:text-venn-grey-80`,
      className,
    )}
  >
    {children}
  </div>
);

export const BLOCK_BORDER_WIDTH_PX = 2;
